export const openBrowser = (url: string) => {
  window.open(url);
};
